export default function updateNavigation(): void {
    const event = new Event('update-navigation');
    window.dispatchEvent(event);
}
